// Helper to determine whether a given discipline is a ring or a tatami discipline
const checkRingOrTatami = (discipline) => {

    const ringDisciplines = ["full_contact", "full_contact_low_kick", "full_contact_k1"];
    const tatamiDisciplines = ["pointfighting", "light_contact", "kick_light"];

    if (ringDisciplines.includes(discipline)) {
        return "ring"
    }

    if (tatamiDisciplines.includes(discipline)) {
        return "tatami"
    }

    return "kumite"

}

module.exports = {
    checkRingOrTatami: checkRingOrTatami
}